import styled from 'styled-components';
import ProgressBarIcon from './ProgressBarIcon';
import ProgressBarLine from './ProgressBarLine';
import { PropTypes } from 'prop-types';

const StepWrap = styled.div`
    display: flex;
    flex: ${props => props.last ? 0 : 1};
`;

function ProgressBarStep(props) {
    if (!props.last) {
        return (
        <StepWrap>
            <ProgressBarIcon active={props.active} icon={props.icon}/>
            <ProgressBarLine />
        </StepWrap>
        )
    }
    return (
        <StepWrap last={props.last}>
            <ProgressBarIcon active={props.active} icon={props.icon} />
        </StepWrap>
   )
}

ProgressBarStep.propTypes = {
    icon: PropTypes.object.isRequired,
    last: PropTypes.bool,
    active: PropTypes.bool,
};

export default ProgressBarStep;